import React, { useState, useEffect } from 'react';
import UserService from '../service';
import { useGetExtensions } from './hooks/useGetExtensions';
import { useGetContexts } from './hooks/useGetContexts';
import { useGetQueues } from './hooks/useGetQueues';
import { useGetProfiles } from './hooks/useGetProfiles';
import ReactQuill from 'react-quill';
import { useGetSectors } from './hooks/useGetSectors';
import { useGetCurrentSelectedQueues } from './hooks/useGetCurrentSelectedQueues';
import { useForm, Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { booleanToString } from './assets/convertDataTypes';
import { DEFAULT_PENALTY } from './assets/constants';
import { toFormatValuesForSending } from './assets/toFormatValuesForSending';
import { QueuePenaltyTable } from './components/QueuePenaltyTable';
import { UpdatePasswordButton } from './components/UpdatePasswordButton';
import { ErrorFormMessage } from './components/ErrorFormMessage';
import { agentCodeRegex } from './assets/regex';
import ReactLoader from 'components/Loader';
import ReactButton from 'components/Buttons/ReactButton';
import FormTooltip from 'components/Inputs/FormTooltip';
import EditPassword from './components/EditPassword';
import ModalUpdatePenality from './components/modalEditPenality';
import FlexSelect from 'components/Inputs/FlexSelect';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import ScaleService from '../../Scales/service';
import { useRequestUsers } from 'hooks/useUserContext';
import { useRecordTypes } from '../../RecordType/hooks/useRecordTypes';
import {
  Container,
  Row,
  Card,
  Form,
  Col,
  Input,
  CardHeader,
  CardBody,
  FormGroup
} from 'reactstrap';
import { useGetTeams } from './hooks/useGetTeams';
import { verifyRoles } from 'components/Authentication/VerifyRoles';
import TelephoneMask from 'components/Inputs/TelephoneMask';
import { maskPhoneNumber } from 'views/CRM/shared/utils/phoneNumberHelpers';
import { useUsers } from 'views/Report/Protocol/hooks/useUsers';

import { ScreenPrompt } from 'components/ScreenPrompt';
import { useQueueChatPauseContext } from 'hooks/useQueuePauseChatServicePanel';
import QueueService from '../../../../src/views/Queue/service';
import _ from 'lodash';
import { useChatTypeOfLimitation } from '../../../hooks/useChatTypeOfLimitation';
import { FlexControllerV2 } from 'components/FlexControllerInput/V2';
import useRingGroups from 'hooks/useRingGroups';
import { useGetQueuesTelephony } from './hooks/useGetTelephonyQueues';

const UserForm = (props) => {
  const { queues: queuesChatMap } = useQueueChatPauseContext();
  const { loadApiUsers } = useRequestUsers();
  const { login } = props.match.params;
  const { recordTypes } = useRecordTypes();
  const {
    reset,
    control,
    handleSubmit,
    errors,
    setValue,
    getValues,
    watch,
    formState
  } = useForm();
  const { isDirty } = formState;

  const controlSelectQueues = watch('queuesid');
  const webrtcExtensions = watch('webrtcextensionsid');
  const history = useHistory();
  const [isUpdate, setIsUpdate] = useState(false);
  const [isDisabledInput, setisDisabledInput] = useState(false);
  const [isDisabledInputLogin, setisDisabledInputLogin] = useState(false);
  const [isAutomaticLoginQueueChat, setIsAutomaticLoginChatQueue] =
    useState(false);
  /**
   * Determina o tipo de redistribuição das conversas deste usuário, após o logout de uma fila específicas.
   * A redistribuição é feita sobre as conversas atribuídas.
   *
   * @typedef {'last_queue' | 'current_queue'} TypeOfRedistribution
   */
  /** @type {[TypeOfRedistribution, React.Dispatch<React.SetStateAction<TypeOfRedistribution>>]} */
  const [typeOfRedistribution, setTypeOfRedistribution] = useState(false);
  const [isSupervisor, setisSupervisor] = useState(false);
  const [workScales, setworkScales] = useState([]);
  const [
    isUserAbleToEditSlaInfoMoreThanOnce,
    setIsUserAbleToEditSlaInfoMoreThanOnce
  ] = useState(false);
  const [queuesTelephony, setQueuesTelephony] = useState([]);
  const [isQueuesTelephone, setIsQueuesTelephone] = useState(false);

  const [loading, setLoading] = useState(false);
  const { extensions } = useGetExtensions();
  const { contexts } = useGetContexts();
  const { queues } = useGetQueues();
  const { queuesTelephony: queuesTele } = useGetQueuesTelephony({ isChat: 'false' });
  const { profiles } = useGetProfiles();
  const { sectors } = useGetSectors();
  const { teams } = useGetTeams(isUpdate);
  const { selectedQueues, setSelectedQueues } = useGetCurrentSelectedQueues({
    login,
    isUpdate,
    queues,
    controlSelectQueues
  });
  const { userList } = useUsers();

  const [openModal, setOpenModal] = useState(false);
  const [showAllLeads, setShowAllLeads] = useState(false);
  const [showAllAccounts, setShowAllAccounts] = useState(false);
  const [showAllProtocols, setShowAllProtocols] = useState(false);
  const [showAllConversations, setShowAllConversations] = useState(false);
  const [showAllOpportunities, setShowAllOpportunities] = useState(false);
  const [user, setUser] = useState(null);
  const [openModalUpdatePenality, setOpenModalUpdatePenality] = useState(false);
  const [queueUpdatePenality, setQueueUpdatePenality] = useState({});
  const [redistributeWhenLogoutOfQueues, setRedistributeWhenLogoutOfQueues] =
    useState(false);
  const [initialConfigSignatureEmail, setInitialConfigSignatureEmail] =
    useState({
      agent_login: login,
      signature: '',
      active: false
    });

  const { currentOption } = useChatTypeOfLimitation();
  const { options: ringGroupsOptions, isLoading: isLoadingRingGroups } =
    useRingGroups();

  function setDataEmailSignature(event) {
    setInitialConfigSignatureEmail({
      ...initialConfigSignatureEmail,
      signature: event
    });
  }

  var modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      [{ font: [] }],
      [{ align: [] }],
      [{ color: [] }, { background: [] }],
      [
        { list: 'ordered' },
        { list: 'bullet' },
        { indent: '-1' },
        { indent: '+1' }
      ],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      ['link', 'image', 'code-block'],
      ['clean']
    ]
  };
  useEffect(() => {
    if (login) {
      setLoading(true);
      UserService.get(login)
        .then((response) => {
          let getUser = response.data.data;

          let arrayQueuesId = [];
          getUser.queues.forEach((queue) => {
            arrayQueuesId.push(queue.id);
          });

          let arrayQueuesTelephonyId = [];
          getUser.queueTelephony.forEach((queue) => {
            arrayQueuesTelephonyId.push(queue.id);
          });

          let arrayCostsCenterId = [];
          getUser.costscenter.forEach((cc) => {
            arrayCostsCenterId.push(cc.id);
          });

          let arrayRecordTypesId = [];
          getUser.recordTypes.forEach((rt) => {
            arrayRecordTypesId.push(rt.id);
          });

          let arrayExtensionsNumber = [];
          getUser.extensions.forEach((extension) => {
            arrayExtensionsNumber.push(extension.extension_number);
          });

          let arrayWebRTCExtensionsNumber = [];
          (getUser.webrtcExtensions || []).forEach((extension) => {
            arrayWebRTCExtensionsNumber.push(extension.extension_number);
          });

          let arrayProfilesId = [];
          getUser.profiles.forEach((profile) => {
            arrayProfilesId.push(profile.id);
          });

          let arrayTeamsId = [];
          getUser.teams.forEach((team) => {
            arrayTeamsId.push(team.id);
          });

          let arrayqueuesidToSignIn = [];
          if (getUser.queuesidToSignIn) {
            getUser.queuesidToSignIn.forEach((response) => {
              arrayqueuesidToSignIn.push(response.id);
            });
          }

          let arrayQueuesIdToSignInChat = [];
          setIsAutomaticLoginChatQueue(getUser.isAutomaticLoginQueueChat);
          setRedistributeWhenLogoutOfQueues(
            getUser.redistribute_when_logout_of_queues
          );
          if (
            getUser?.queuesIdToSignInChat &&
            getUser.queuesIdToSignInChat?.length
          ) {
            getUser.queuesIdToSignInChat.forEach((response) => {
              arrayQueuesIdToSignInChat.push(response.id);
            });
          }

          const supervisorids = getUser?.supervisors?.map(
            (supervisor) => supervisor.login
          );

          let arrayRingGroups = [];
          if (getUser.ringGroups && Array.isArray(getUser.ringGroups)) {
            arrayRingGroups = getUser.ringGroups.map((rg) => ({
              label: rg.name,
              value: rg.id
            }));
          }

          if (getUser.show_all_conversations === true)
            setShowAllConversations(true);

          if (getUser.scale?.id > 0) {
            setisDisabledInput(true);
          } else {
            setisDisabledInput(false);
          }

          if (getUser.show_all_protocols === true) setShowAllProtocols(true);

          if (getUser.show_use_off_queues === true) setIsQueuesTelephone(true);

          getUser = {
            ...getUser,
            costscenterid: arrayCostsCenterId,
            recordtypesid: arrayRecordTypesId,
            extensionsid: arrayExtensionsNumber,
            webrtcextensionsid: arrayWebRTCExtensionsNumber,
            queuesid: arrayQueuesId,
            profilesid: arrayProfilesId,
            supervisorids,
            dark_mode: booleanToString(getUser.dark_mode),
            scaleId: getUser?.scale?.id ?? '',
            queuesidToSignIn: arrayqueuesidToSignIn,
            teamsIds: arrayTeamsId,
            telephone: maskPhoneNumber(getUser.telephone),
            queuesIdToSignInChat: arrayQueuesIdToSignInChat,
            queues_telephone:
              getUser.show_use_off_queues === true
                ? arrayQueuesTelephonyId
                : [],
            ringgroups: arrayRingGroups
          };

          // Quando não houver valor configurado para o limite de conversas, assumir 0 como padrão
          getUser.max_chats_in_attendance ??
            (getUser.max_chats_in_attendance = 0);

          getUser.shouldBeAbleToEditTheSLAInfoMoreThanOnce =
            getUser.isAbleToEditSlaInfoMoreThanOnce;
          getUser.shouldBeAbleToEditTheSLAInfoMoreOnlyOnce =
            !getUser.isAbleToEditSlaInfoMoreThanOnce;

          setIsUserAbleToEditSlaInfoMoreThanOnce(
            getUser.isAbleToEditSlaInfoMoreThanOnce
          );
          setisDisabledInputLogin(getUser.should_sign_in_asterisk);
          setTypeOfRedistribution(
            !getUser?.type_of_redistribution
              ? 'current_queue'
              : getUser.type_of_redistribution
          );

          reset(getUser);

          setUser({ ...getUser });
          setisSupervisor(getUser.isSupervisor);
          setIsUpdate(true);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          toast.error('Erro ao carregar usuário!', {
            autoClose: 3000,
            closeOnClick: true
          });
          setLoading(false);
        });
    } else {
      reset({
        max_chats_in_attendance: 0
      });
    }
  }, [login, reset]);

  useEffect(() => {
    QueueService.getAll()
      .then((res) => {
        const login = user?.login;
        if (login) {
          UserService.get(login)
            .then(() => {
              const queueIdsFromValues = getValues('queuesid') || [];
              const additionalQueues = res?.data?.data?.filter(
                (queue) =>
                  queueIdsFromValues.some((id) => id === Number(queue?.id)) &&
                  queue?.is_telephony
              );

              const combinedQueues = [...additionalQueues];
              const uniqueQueues = combinedQueues?.filter(
                (queue, index, self) =>
                  index === self.findIndex((q) => q?.id === queue?.id)
              );

              const orderedQueues = _.orderBy(
                uniqueQueues,
                [(user) => user?.name?.toLowerCase()],
                'asc'
              );

              setQueuesTelephony(orderedQueues || []);
            })
            .catch((err) => {
              const message =
                (err.response && err.response.data) || 'Erro ao carregar filas';
              toast.error(message, {
                autoClose: 3000,
                closeOnClick: true
              });
            });
        } else {
          const queueIdsFromValues = getValues('queuesid') || [];
          const additionalQueues = res?.data?.data?.filter(
            (queue) =>
              queueIdsFromValues.some((id) => id === Number(queue?.id)) &&
              queue?.is_telephony
          );

          const combinedQueues = [...additionalQueues];
          const uniqueQueues = combinedQueues?.filter(
            (queue, index, self) =>
              index === self.findIndex((q) => q?.id === queue?.id)
          );

          const orderedQueues = _.orderBy(
            uniqueQueues,
            [(user) => user?.name?.toLowerCase()],
            'asc'
          );

          setQueuesTelephony(orderedQueues || []);
        }
      })
      .catch((err) => {
        const message =
          (err.response && err.response.data) || 'Erro ao carregar filas';
        toast.error(message, {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  }, [user, getValues('queuesid')]);

  useEffect(() => {
    const currentSelectedQueues = [];

    if (isUpdate) {
      const { penalties } = user; //caso seja usuario cadastrado no novo formato
      const queuesOldUser = user?.queues; //caso seja usuario cadastrado no formando antigo
      const penaltyDefaultOld = user?.penalty;
      const queuesToBeRemoved = [];

      if (user?.signatureEmail) {
        setInitialConfigSignatureEmail({
          signature: user?.signatureEmail.signature || '',
          agent_login: login,
          active: user?.signatureEmail.active || false
        });
      }

      if (penalties.length > 0) {
        // 'entrou usuario novo';
        queues.forEach((queue) => {
          penalties.forEach((penalty) => {
            if (queue?.id === penalty?.queue_id) {
              currentSelectedQueues.push({
                label: queue?.name,
                value: queue?.id,
                penality: penalty?.penalty
              });
            }
          });
        });
      } else {
        // 'chegou usuario antigo'
        queues.forEach((queue) => {
          queuesOldUser.forEach((queueOld) => {
            if (queue.id === queueOld.id) {
              currentSelectedQueues.push({
                label: queue?.name,
                value: queue?.id,
                penality: penaltyDefaultOld || DEFAULT_PENALTY
              });
            }
          });
        });
      }

      controlSelectQueues.forEach((selectQueue) => {
        let found = currentSelectedQueues.findIndex(
          (currentQueue) => currentQueue?.value === selectQueue
        );

        if (found === -1) {
          const newQueueInsert = queues.find(
            (queue) => queue?.id === selectQueue
          );

          currentSelectedQueues.push({
            label: newQueueInsert?.name,
            value: newQueueInsert?.id,
            penality: DEFAULT_PENALTY
          });
        }
      });

      currentSelectedQueues.forEach((currentQueue) => {
        const found = controlSelectQueues.find(
          (selectQueue) => currentQueue?.value === selectQueue
        );
        if (found === undefined) {
          queuesToBeRemoved.push(currentQueue);
        }
      });

      queuesToBeRemoved.forEach((queueRemoved) => {
        const itemsRemove = currentSelectedQueues.findIndex(
          (currentQueue) => currentQueue?.value === queueRemoved?.value
        );
        currentSelectedQueues.splice(itemsRemove, 1);
      });

      setSelectedQueues(currentSelectedQueues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [controlSelectQueues, isUpdate, queues, user]);

  async function loadApiScale() {
    const Params = {
      page: 0,
      size: 0,
      showDisable: false,
      querySearch: ''
    };
    ScaleService.getAllSearch(
      Params.showDisabled,
      Params.size,
      Params.page,
      Params.querySearch
    ).then((response) => {
      const getScale = response.data.data.map((scale) => {
        return {
          name: scale.name,
          id: scale.id
        };
      });
      setworkScales(getScale);
    });
  }

  useEffect(() => {
    loadApiScale();
  }, []);

  const onSubmit = async (data) => {
    setLoading(true);
    data = { scaleId: null, ...data };
    try {
      let formatedData = toFormatValuesForSending(
        data,
        user,
        selectedQueues,
        showAllConversations,
        isUpdate,
        isDisabledInputLogin,
        isDisabledInput,
        isSupervisor,
        showAllProtocols,
        initialConfigSignatureEmail,
        isUpdate,
        typeOfRedistribution
      );

      if (data.show_use_off_queues === false) {
        delete formatedData.queues_telephone;
        delete data.queues_telephone;
      }

      if (data.supervisorids === null || data.supervisorids === '') {
        delete formatedData.supervisorids;
      }

      formatedData = {
        ...formatedData,
        isAbleToEditSlaInfoMoreThanOnce: isUserAbleToEditSlaInfoMoreThanOnce,
        redistribute_when_logout_of_queues: redistributeWhenLogoutOfQueues,
        ringgroupids: data.ringgroups?.map?.((opt) => opt.value)
      };

      if (data.ringgroups?.length) delete formatedData.ringgroups;

      if (currentOption?.value === 'limited-by-agent') {
        formatedData.max_chats_in_attendance = data.max_chats_in_attendance;
      }

      formatedData.isAutomaticLoginQueueChat = isAutomaticLoginQueueChat;

      if (login === localStorage.getItem('login')) {
        localStorage.setItem('show_all_conversations', showAllConversations);
        localStorage.setItem('show_all_protocols', showAllProtocols);
      }

      isUpdate
        ? await UserService.update(login, formatedData)
        : await UserService.create(formatedData);

      const uniqueTeams = [...new Set([data.teamId, ...data.teamsIds])];
      const teams = JSON.stringify(uniqueTeams);

      localStorage.setItem('teams', teams);

      loadApiUsers();

      history.push('/admin/user');

      toast.success(
        isUpdate
          ? 'Usuário alterado com sucesso!'
          : 'Usuário cadastrado com sucesso!',
        {
          autoClose: 3000,
          closeOnClick: true
        }
      );
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error(err.response?.data?.message || 'Ops, ocorreu um erro!', {
        autoClose: 3000,
        closeOnClick: true
      });
    }
  };

  const onInvalid = (errors) => {
    const firstErrorElement = document.getElementsByName(
      Object.keys(errors)?.[0]
    );

    // eslint-disable-next-line
    firstErrorElement.length && firstErrorElement?.[0]?.focus?.();
  };

  const errorFormMessage = (message) => <ErrorFormMessage message={message} />;

  const cancelAction = () => {
    history.push('/admin/user');
  };

  const toggleModal = () => {
    setOpenModal(!openModal);
  };

  const handleOpenModalUpdatePenality = (queueUpdate) => {
    setQueueUpdatePenality(queueUpdate);
    setOpenModalUpdatePenality(true);
  };
  const handleWithQueueLogin = () => {
    if (isDisabledInput) {
      setisDisabledInputLogin(true);
    } else {
      setisDisabledInputLogin(!isDisabledInputLogin);
    }
  };

  const handleWithSupervisor = () => {
    setisSupervisor(!isSupervisor);
    setisDisabledInputLogin(false);
    setisDisabledInput(false);
  };

  const handleWithAutomaticQueueChatLogin = () => {
    setIsAutomaticLoginChatQueue(!isAutomaticLoginQueueChat);
  };

  return (
    <>
      <ScreenPrompt
        when={isDirty && !formState.isSubmitting}
        message={`Está certo de que deseja sair? Terá que preencher os dados novamente quando retornar`}
      />
      <SimpleHeader
        name="Form validation"
        parentName="Forms"
        returnPath="/admin/user"
        buttonTitle="Voltar para a pagina de usuários"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3>Usuário</h3>
                </CardHeader>
                <CardBody>
                  <>
                    {login && (
                      <UpdatePasswordButton toggleModal={toggleModal} />
                    )}
                    <Form
                      className="needs-validation"
                      onSubmit={handleSubmit(onSubmit, onInvalid)}
                      autoComplete="off"
                    >
                      <Row
                        className="mb-1"
                        style={{ display: 'block', padding: '1rem' }}
                      >
                        <Row className="mb-3">
                          <Col>
                            <h3 className="mb-1">Principal</h3>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">Nome*</label>
                            <Controller
                              as={Input}
                              control={control}
                              name="name"
                              rules={{ required: 'Nome é obrigatório!' }}
                              defaultValue=""
                            />
                            <ErrorMessage
                              errors={errors}
                              name="name"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">
                              Usuário*
                            </label>
                            <Controller
                              as={<Input disabled={isUpdate} />}
                              control={control}
                              name="login"
                              rules={{
                                pattern: {
                                  value: /^[a-z0-9.@*_-]*$/,
                                  message:
                                    'O nome de usuário não deve conter espaços ou letras em caixa alta!'
                                },
                                required: 'Usuário é obrigatório!'
                              }}
                              defaultValue=""
                            />
                            <ErrorMessage
                              errors={errors}
                              name="login"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                        </Row>

                        {!login && (
                          <Row className="mb-3">
                            <Col md="6">
                              <label className="form-control-label">
                                Senha*
                              </label>
                              <Controller
                                as={<Input
                                  type="text"
                                  style={{ "text-security": "disc", "-webkit-text-security": "disc" }}
                                  name="password"
                                  autoComplete="new-password"
                                  data-lpignore="true"
                                  data-1p-ignore
                                />}
                                control={control}
                                name="password"
                                rules={{
                                  required: 'Por favor, digite a senha!'
                                }}
                                defaultValue=""
                              />
                              <ErrorMessage
                                errors={errors}
                                name="password"
                                render={({ message }) =>
                                  errorFormMessage(message)
                                }
                              />
                            </Col>
                            <Col md="6">
                              <label className="form-control-label">
                                Confirmar senha*
                              </label>
                              <Controller
                                as={<Input
                                  type="text"
                                  style={{ "text-security": "disc", "-webkit-text-security": "disc" }}
                                  name="confirm_password"
                                  autoComplete="new-password"
                                  data-lpignore="true"
                                  data-1p-ignore
                                />}
                                control={control}
                                name="confirm_password"
                                rules={{
                                  required:
                                    'Por favor, digite a confirmação da senha!',
                                  validate: (value) => {
                                    if (value === getValues()['password']) {
                                      return true;
                                    } else {
                                      return 'As senhas não conferem!';
                                    }
                                  }
                                }}
                                defaultValue=""
                              />
                              <ErrorMessage
                                errors={errors}
                                name="confirm_password"
                                render={({ message }) =>
                                  errorFormMessage(message)
                                }
                              />
                            </Col>
                          </Row>
                        )}

                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">Email</label>
                            <Controller
                              as={<Input type="email" />}
                              control={control}
                              name="email"
                              defaultValue=""
                            />
                            <ErrorMessage
                              errors={errors}
                              name="email"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">
                              Telefone
                            </label>
                            <Controller
                              render={(props) => (
                                <TelephoneMask
                                  valueController={setValue}
                                  fieldName="telephone"
                                  value={props.value}
                                  placeholder="(99) 91234-5678"
                                />
                              )}
                              control={control}
                              defaultValue=""
                              rules={{
                                validate: (value) => {
                                  if (!value) return true;
                                  let phoneFormated = value.replace(/\D/g, '');
                                  phoneFormated = phoneFormated.replace(
                                    /^0/,
                                    ''
                                  );

                                  if (
                                    phoneFormated.length < 10 &&
                                    phoneFormated.length > 0
                                  ) {
                                    return 'Telefone inválido';
                                  }
                                  return true;
                                }
                              }}
                              name="telephone"
                            />
                            <ErrorMessage
                              errors={errors}
                              name="telephone"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Código do agente*
                              <FormTooltip
                                text="Este código é usado para realizar chamadas em ramais
                                bloqueados."
                              />
                            </label>
                            {isUpdate ? (
                              <Controller
                                as={<Input disabled />}
                                control={control}
                                name="agent_code"
                                value={props.value}
                                defaultValue=""
                              />
                            ) : (
                              <Controller
                                as={Input}
                                type="number"
                                control={control}
                                name="agent_code"
                                rules={{
                                  required:
                                    'Código do agente é um campo obrigatório!',
                                  pattern: {
                                    value: agentCodeRegex,
                                    message:
                                      'Código do agente deve possuir entre 4 a 12 dígitos'
                                  }
                                }}
                                defaultValue=""
                              />
                            )}
                            <ErrorMessage
                              errors={errors}
                              name="agent_code"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>

                          <Col md="6">
                            <label className="form-control-label">
                              Código PIN
                            </label>
                            <Controller
                              as={Input}
                              control={control}
                              name="pin_code"
                              defaultValue={''}
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Perfil de acesso*
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  isClearable={true}
                                  dataOptions={profiles}
                                  isMulti={false}
                                  closeMenuOnSelect={true}
                                  value={props.value}
                                  valueController={setValue}
                                  fieldName="profileId"
                                  labelName="name"
                                  valueName="id"
                                />
                              )}
                              control={control}
                              name="profileId"
                              defaultValue=""
                              rules={{
                                required: 'Perfil de acesso é obrigatório!'
                              }}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="profileId"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">
                              Nickname
                            </label>
                            <Controller
                              as={Input}
                              control={control}
                              name="nickname"
                              maxLength="30"
                              rules={{
                                pattern: {
                                  value: /^[a-z0-9.@*_-]*$/,
                                  message:
                                    'O Nickname não deve conter espaços ou letras em caixa alta!'
                                }
                              }}
                              defaultValue=""
                            />
                            <ErrorMessage
                              errors={errors}
                              name="nickname"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Contexto*
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  isClearable={true}
                                  dataOptions={contexts}
                                  isMulti={false}
                                  closeMenuOnSelect={true}
                                  value={props.value}
                                  valueController={setValue}
                                  fieldName="context"
                                  labelName="name"
                                  valueName="id"
                                />
                              )}
                              control={control}
                              name="context"
                              defaultValue=""
                              rules={{
                                required: 'Contexto é obrigatório!'
                              }}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="context"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">
                              Equipe do usuário*
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  isClearable={true}
                                  dataOptions={teams}
                                  isMulti={false}
                                  closeMenuOnSelect={true}
                                  value={props.value}
                                  valueController={setValue}
                                  fieldName="teamId"
                                  labelName="name"
                                  valueName="id"
                                />
                              )}
                              control={control}
                              name="teamId"
                              defaultValue=""
                              rules={{
                                required: 'A Equipe do usuário é obrigatória!'
                              }}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="teamId"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">Setor</label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  isClearable={true}
                                  dataOptions={sectors}
                                  isMulti={false}
                                  closeMenuOnSelect={true}
                                  value={props.value}
                                  valueController={setValue}
                                  fieldName="costCenterId"
                                  labelName="name"
                                  valueName="id"
                                />
                              )}
                              control={control}
                              name="costCenterId"
                              defaultValue=""
                            />
                            <ErrorMessage
                              errors={errors}
                              name="costCenterId"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                        </Row>
                      </Row>

                      <Row className="mb-3">
                        <Col>
                          <h3 className="mb-1">Integrações</h3>
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col md="6">
                          <label className="form-control-label">
                            Usuário
                            <FormTooltip
                              text="Este nome de usuário será utilizado na configuração de URL de integração para uso na Tela de Sistemas, que autenticará em sistemas de terceiros."
                            />
                          </label>
                          <Controller
                            as={
                              <Input
                                type="text"
                                name="integration_login"
                                autoComplete="off"
                                data-lpignore="true"
                                data-1p-ignore
                              />
                            }
                            control={control}
                            name="integration_login"
                            rules={{
                              pattern: {
                                value: /^[a-z0-9.@*_-]*$/,
                                message:
                                  'O nome de usuário não deve conter espaços ou letras em caixa alta!'
                              }
                            }}
                            defaultValue=""
                          />
                          <ErrorMessage
                            errors={errors}
                            name="integration_login"
                            render={({ message }) => errorFormMessage(message)}
                          />
                        </Col>

                        <Col md="6">
                          <label className="form-control-label">
                            Senha
                            <FormTooltip
                              text="Esta senha será utilizada na configuração de URL de
          integração para uso na Tela de Sistemas, que autenticará em
          sistemas de terceiros."
                            />
                          </label>
                          <Controller
                            as={
                              <Input
                                type="text"
                                style={{ "text-security": "disc", "-webkit-text-security": "disc" }}
                                name="integration_password"
                                autoComplete="new-password"
                                data-lpignore="true"
                                data-1p-ignore
                              />
                            }
                            control={control}
                            name="integration_password"
                            defaultValue=""
                          />
                          <ErrorMessage
                            errors={errors}
                            name="integration_password"
                            render={({ message }) => errorFormMessage(message)}
                          />
                        </Col>
                      </Row>

                      <Row
                        className="mb-1"
                        style={
                          verifyRoles(['USER_SCALE_PROFILE'])
                            ? { display: 'block', padding: '1rem' }
                            : { display: 'none' }
                        }
                      >
                        <Row>
                          <Col>
                            <Row>
                              <Col>
                                <h3 className="mb-1">Escalas</h3>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="6">
                                <FormGroup className="mb-0">
                                  <label className="form-control-label">
                                    <input
                                      type="checkbox"
                                      checked={isDisabledInputLogin}
                                      onChange={() => handleWithQueueLogin()}
                                      disabled={isDisabledInput || isSupervisor}
                                      style={{ marginRight: '0.35rem' }}
                                    />
                                    Logar nas filas automaticamente ao logar no
                                    sistema
                                  </label>
                                </FormGroup>
                              </Col>

                              <Col>
                                <Row>
                                  <Col sm="12">
                                    <FormGroup className="mb-0">
                                      <label className="form-control-label">
                                        <input
                                          type="checkbox"
                                          checked={isDisabledInput}
                                          onChange={() => {
                                            setisDisabledInputLogin(true);
                                            setisDisabledInput(
                                              !isDisabledInput
                                            );
                                          }}
                                          disabled={isSupervisor}
                                          style={{ marginRight: '0.5rem' }}
                                        />
                                        Utilizar escala de trabalho ao logar
                                      </label>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="6">
                            {isDisabledInputLogin ? (
                              <>
                                <label className="form-control-label">
                                  Selecione a Fila(s) para login automático.
                                </label>
                                <Controller
                                  render={(props) => (
                                    <FlexSelect
                                      dataOptions={queuesTele}
                                      placeholder="Selecione a(s) fila(s)"
                                      isClearable={true}
                                      isMulti={true}
                                      value={props.value}
                                      valueController={setValue}
                                      fieldName="queuesidToSignIn"
                                      labelName="name"
                                      valueName="id"
                                    />
                                  )}
                                  control={control}
                                  name="queuesidToSignIn"
                                  defaultValue=""
                                  rules={{
                                    required: 'Selecione pelo menos uma fila!'
                                  }}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  name="queuesidToSignIn"
                                  render={({ message }) =>
                                    errorFormMessage(message)
                                  }
                                />
                              </>
                            ) : (
                              <></>
                            )}
                          </Col>
                          <Col md="6">
                            {isDisabledInput ? (
                              <>
                                <label className="form-control-label">
                                  Escalas
                                </label>
                                <Controller
                                  render={(props) => (
                                    <FlexSelect
                                      dataOptions={workScales}
                                      placeholder="Selecione a escala"
                                      isClearable={true}
                                      isMulti={false}
                                      value={props.value}
                                      valueController={setValue}
                                      fieldName="scaleId"
                                      labelName="name"
                                      valueName="id"
                                    />
                                  )}
                                  control={control}
                                  name="scaleId"
                                  defaultValue=""
                                />
                              </>
                            ) : (
                              <></>
                            )}
                          </Col>
                        </Row>

                        <Row>
                          <Col sm="12">
                            <FormGroup className="mt-2">
                              <label className="form-control-label">
                                <input
                                  type="checkbox"
                                  checked={isSupervisor}
                                  onChange={() => {
                                    handleWithSupervisor();
                                  }}
                                  style={{ marginRight: '0.5rem' }}
                                />
                                Supervisor
                              </label>
                            </FormGroup>
                          </Col>
                        </Row>
                      </Row>

                      <Row
                        className="mb-1"
                        style={
                          verifyRoles(['USER_SCALE_PROFILE'])
                            ? { display: 'block', padding: '1rem' }
                            : { display: 'none' }
                        }
                      >
                        <Row>
                          <Col>
                            <Row>
                              <Col>
                                <h3 className="mb-1">Chat</h3>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <label
                                  className="form-control-label"
                                  style={{ marginLeft: '20px' }}
                                >
                                  <Input
                                    type="checkbox"
                                    checked={redistributeWhenLogoutOfQueues}
                                    onChange={(e) => {
                                      setRedistributeWhenLogoutOfQueues(
                                        e.target.checked
                                      );
                                    }}
                                  />
                                  Redistribuir conversas não atendidas ao
                                  deslogar da fila
                                </label>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <label className="form-control-label">
                                  Limite de conversas do usuário
                                  <FormTooltip text="O campo só estará ativado quando o modo de limite de distribuição de conversas estiver definido como 'limitar por agente'" />
                                </label>
                                <Controller
                                  control={control}
                                  name="max_chats_in_attendance"
                                  rules={{
                                    required:
                                      'O limite de conversas é obrigatório',
                                    min: {
                                      value: 0,
                                      message:
                                        'O limite de conversas deve ser maior ou igual a 0'
                                    }
                                  }}
                                  render={(renderProps) => (
                                    <Input
                                      {...renderProps}
                                      type="number"
                                      disabled={
                                        currentOption?.value !=
                                        'limited-by-agent'
                                      }
                                      onChange={(e) => {
                                        const value =
                                          e.target.value === ''
                                            ? ''
                                            : Number(e.target.value);
                                        renderProps.onChange(value);
                                      }}
                                    />
                                  )}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  name="max_chats_in_attendance"
                                  render={({ message }) => (
                                    <p style={{ color: 'red' }}>{message}</p>
                                  )}
                                />
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <FormGroup className="mb-0">
                                  <label className="form-control-label">
                                    <input
                                      type="checkbox"
                                      checked={isAutomaticLoginQueueChat}
                                      onChange={() =>
                                        handleWithAutomaticQueueChatLogin()
                                      }
                                      style={{ marginRight: '0.35rem' }}
                                    />
                                    Logar nas filas automaticamente ao logar no
                                    sistema
                                  </label>
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col md="6">
                                <label className="form-control-label">
                                  Tipo de redistribuição de conversas atribuidas
                                </label>
                                <Controller
                                  render={(props) => (
                                    <FlexSelect
                                      dataOptions={[
                                        {
                                          label: 'Fila atual',
                                          value: 'current_queue'
                                        },
                                        {
                                          label: 'Última fila',
                                          value: 'last_queue'
                                        }
                                      ]}
                                      isMulti={false}
                                      value={props.value}
                                      valueController={setValue}
                                      fieldName="type_of_redistribution"
                                      labelName="label"
                                      valueName="value"
                                      closeMenuOnSelect
                                      onChange={(option) => {
                                        props.onChange(option);
                                        setTypeOfRedistribution(option?.value);
                                      }}
                                    />
                                  )}
                                  control={control}
                                  name="type_of_redistribution"
                                  defaultValue={
                                    user?.type_of_redistribution
                                      ? {
                                        label:
                                          user.type_of_redistribution ===
                                            'current_queue'
                                            ? 'Fila atual'
                                            : 'Última fila',
                                        value: user.type_of_redistribution
                                      }
                                      : {
                                        label: 'Fila atual',
                                        value: 'current_queue'
                                      }
                                  }
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="6">
                            {isAutomaticLoginQueueChat ? (
                              <>
                                <label className="form-control-label">
                                  Selecione a Fila(s) para login automático.
                                </label>
                                <Controller
                                  render={(props) => (
                                    <FlexSelect
                                      dataOptions={Array.from(
                                        queuesChatMap.values() || []
                                      )}
                                      placeholder="Selecione a(s) fila(s)"
                                      isClearable={true}
                                      isMulti={true}
                                      value={props.value}
                                      valueController={setValue}
                                      fieldName="queuesIdToSignInChat"
                                      labelName="name"
                                      valueName="id"
                                    />
                                  )}
                                  control={control}
                                  name="queuesIdToSignInChat"
                                  defaultValue=""
                                  rules={{
                                    required: 'Selecione pelo menos uma fila!'
                                  }}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  name="queuesIdToSignInChat"
                                  render={({ message }) =>
                                    errorFormMessage(message)
                                  }
                                />
                              </>
                            ) : (
                              <></>
                            )}
                          </Col>
                        </Row>
                      </Row>

                      <Row
                        className="mb-1"
                        style={
                          verifyRoles(['SLA_MATRIX'])
                            ? { display: 'block', padding: '1rem' }
                            : { display: 'none' }
                        }
                      >
                        <Row>
                          <Col>
                            <Row>
                              <Col>
                                <h3 className="mb-1">SLA do protocolo</h3>
                              </Col>
                            </Row>
                            <Row>
                              <Col className="mx-4 col-sm-12 col-md-6">
                                <Controller
                                  name={
                                    'shouldBeAbleToEditTheSLAInfoMoreThanOnce'
                                  }
                                  defaultValue={
                                    isUserAbleToEditSlaInfoMoreThanOnce
                                  }
                                  control={control}
                                  render={(props) => {
                                    return (
                                      <>
                                        <label className="form-control-label">
                                          <Input
                                            type="checkbox"
                                            onChange={(e) => {
                                              if (!props.value) {
                                                props.onChange(
                                                  e.target.checked
                                                );
                                                if (e.target.checked) {
                                                  setValue(
                                                    'shouldBeAbleToEditTheSLAInfoMoreOnlyOnce',
                                                    false
                                                  );
                                                }
                                              }
                                              setIsUserAbleToEditSlaInfoMoreThanOnce(
                                                e.target.checked
                                              );
                                            }}
                                            checked={props.value}
                                          />
                                          Permitir alterar Tipo e Urgência mais
                                          de uma vez
                                          <FormTooltip text="Ao marcar essa opção, todos os protocolos criados com essas configurações poderão ter seus valores de motivo e/ou submotivos alterados mais de uma vez." />
                                        </label>
                                      </>
                                    );
                                  }}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col className="mx-4 col-sm-12 col-md-6">
                                <Controller
                                  name={
                                    'shouldBeAbleToEditTheSLAInfoMoreOnlyOnce'
                                  }
                                  defaultValue={
                                    !isUserAbleToEditSlaInfoMoreThanOnce
                                  }
                                  control={control}
                                  render={(props) => {
                                    return (
                                      <>
                                        <label className="form-control-label">
                                          <Input
                                            type="checkbox"
                                            onChange={(e) => {
                                              if (!props.value) {
                                                props.onChange(
                                                  e.target.checked
                                                );
                                                if (e.target.checked) {
                                                  setValue(
                                                    'shouldBeAbleToEditTheSLAInfoMoreThanOnce',
                                                    false
                                                  );
                                                }
                                              }

                                              setIsUserAbleToEditSlaInfoMoreThanOnce(
                                                !e.target.checked
                                              );
                                            }}
                                            checked={props.value}
                                          />
                                          Permitir alterar Tipo e Urgência
                                          apenas uma vez
                                          <FormTooltip text="Ao marcar essa opção, todos os protocolos criados com essas configurações poderão ter seus valores de motivo e/ou submotivos alterados apenas uma vez." />
                                        </label>
                                      </>
                                    );
                                  }}
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Row>

                      <Row
                        className="mb-1"
                        style={
                          verifyRoles(['USER_PERMISSIONS'])
                            ? { display: 'block', padding: '1rem' }
                            : { display: 'none' }
                        }
                      >
                        <Row>
                          <Col>
                            <Row>
                              <Col>
                                <h3 className="mb-1">Permissões</h3>
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col sm="12" md="6" className="mx-4">
                                <Controller
                                  name="show_all_conversations"
                                  control={control}
                                  render={(props) => (
                                    <>
                                      <label className="form-control-label">
                                        <Input
                                          type="checkbox"
                                          onChange={(e) => {
                                            props.onChange(e.target.checked);
                                            setShowAllConversations(
                                              !showAllConversations
                                            );
                                          }}
                                          checked={props.value}
                                        />
                                        Relatório de conversas de todos os
                                        usuários
                                        <FormTooltip text="Habilitando este atributo o usuário passará a visualizar todas as conversas de todos os atendentes nos relatórios, não apenas as suas próprias." />
                                      </label>
                                    </>
                                  )}
                                  defaultValue=""
                                />
                              </Col>
                              <Col sm="12" md="6" className="mx-4">
                                <Controller
                                  name="show_all_protocols"
                                  control={control}
                                  render={(props) => (
                                    <>
                                      <label className="form-control-label">
                                        <Input
                                          type="checkbox"
                                          onChange={(e) => {
                                            props.onChange(e.target.checked);
                                            setShowAllProtocols(
                                              !showAllProtocols
                                            );
                                          }}
                                          checked={props.value}
                                        />
                                        Visualizar protocolos de todos os
                                        usuários
                                        <FormTooltip text="Habilitando este atributo o usuário passará a visualizar todos os protocolos de todos os atendentes, caso o contrário, visualizará apenas seus próprios protocolos." />
                                      </label>
                                    </>
                                  )}
                                  defaultValue=""
                                />
                              </Col>
                              <Col sm="12" md="6" className="mx-4">
                                <Controller
                                  name="show_all_leads"
                                  control={control}
                                  render={(props) => (
                                    <>
                                      <label className="form-control-label">
                                        <Input
                                          type="checkbox"
                                          onChange={(e) => {
                                            props.onChange(e.target.checked);
                                            setShowAllLeads(!showAllLeads);
                                          }}
                                          checked={props.value}
                                        />
                                        Leads de todos os usuários
                                        <FormTooltip text="Habilitando este atributo o usuário passará a visualizar todos os Leads de todos os atendentes, caso contrário, visualizará apenas seus próprios Leads." />
                                      </label>
                                    </>
                                  )}
                                  defaultValue=""
                                />
                              </Col>
                              <Col sm="12" md="6" className="mx-4">
                                <Controller
                                  name="show_all_opportunities"
                                  control={control}
                                  render={(props) => (
                                    <>
                                      <label className="form-control-label">
                                        <Input
                                          type="checkbox"
                                          onChange={(e) => {
                                            props.onChange(e.target.checked);
                                            setShowAllOpportunities(
                                              !showAllOpportunities
                                            );
                                          }}
                                          checked={props.value}
                                        />
                                        Oportunidades de todos os usuários
                                        <FormTooltip text="Habilitando este atributo o usuário passará a visualizar todas as Oportunidades de todos os atendentes, caso contrário, visualizará apenas suas próprias Oportunidades." />
                                      </label>
                                    </>
                                  )}
                                  defaultValue=""
                                />
                              </Col>
                              <Col sm="12" md="6" className="mx-4">
                                <Controller
                                  name="show_all_accounts"
                                  control={control}
                                  render={(props) => (
                                    <>
                                      <label className="form-control-label">
                                        <Input
                                          type="checkbox"
                                          onChange={(e) => {
                                            props.onChange(e.target.checked);
                                            setShowAllAccounts(
                                              !showAllAccounts
                                            );
                                          }}
                                          checked={props.value}
                                        />
                                        Contas de todos os usuários
                                        <FormTooltip text="Habilitando este atributo o usuário passará a visualizar todas as Contas de todos os atendentes, caso contrário, visualizará apenas suas próprias Contas." />
                                      </label>
                                    </>
                                  )}
                                  defaultValue=""
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row className="mb-4">
                          <Col md="6">
                            <label className="form-control-label">Ramais</label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={extensions}
                                  placeholder="Selecione os ramais"
                                  isClearable={true}
                                  isMulti={true}
                                  value={props.value}
                                  valueController={setValue}
                                  fieldName="extensionsid"
                                  labelName="extension_number"
                                  valueName="extension_number"
                                />
                              )}
                              control={control}
                              name="extensionsid"
                              defaultValue=""
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">
                              Ramais permitidos para Softphone
                            </label>
                            <Controller
                              render={(props) => {
                                return (
                                  <FlexSelect
                                    dataOptions={extensions.filter(
                                      (extension) =>
                                        extension.transport === 'WSS'
                                    )}
                                    placeholder="Selecione os ramais"
                                    isClearable={true}
                                    isMulti={true}
                                    value={props.value}
                                    onChange={() => {
                                      if (props.target?.length !== 1) {
                                        setValue('webrtc_auto_login', false);
                                      }
                                    }}
                                    valueController={setValue}
                                    fieldName="webrtcextensionsid"
                                    labelName="extension_number"
                                    valueName="extension_number"
                                  />
                                );
                              }}
                              control={control}
                              name="webrtcextensionsid"
                              defaultValue=""
                            />
                            <Row
                              style={{
                                marginLeft: '1.3rem',
                                marginTop: '0.5rem'
                              }}
                            >
                              <Controller
                                name="webrtc_auto_login"
                                control={control}
                                render={(props) => (
                                  <>
                                    <label className="form-control-label">
                                      <Input
                                        type="checkbox"
                                        onChange={(e) => {
                                          props.onChange(e.target.checked);
                                        }}
                                        checked={props.value}
                                        disabled={webrtcExtensions?.length != 1}
                                      />
                                      Logar automaticamente no softphone
                                    </label>
                                    <FormTooltip text="Só é possível habilitar esta opção se tiver apenas um ramal selecionado." />
                                  </>
                                )}
                                defaultValue=""
                              />
                            </Row>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Criação de novos usuários
                              <FormTooltip text="Campo para adição de quais são os tipos de perfis permitidos que este usuário poderá criar e fazer alterações." />
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={profiles}
                                  placeholder="Selecione os perfis"
                                  isMulti={true}
                                  value={props.value}
                                  valueController={setValue}
                                  fieldName="profilesid"
                                  labelName="name"
                                  valueName="id"
                                />
                              )}
                              control={control}
                              name="profilesid"
                              defaultValue=""
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">
                              Fila(s)
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={queues}
                                  placeholder="Selecione a(s) fila(s)"
                                  isClearable={true}
                                  isMulti={true}
                                  value={props.value}
                                  valueController={setValue}
                                  fieldName="queuesid"
                                  labelName="name"
                                  valueName="id"
                                />
                              )}
                              control={control}
                              name="queuesid"
                              defaultValue=""
                            />
                            <Row
                              style={{
                                marginLeft: '1.3rem',
                                marginTop: '0.5rem'
                              }}
                            >
                              <Controller
                                name="show_use_off_queues"
                                control={control}
                                render={(props) => (
                                  <>
                                    <label className="form-control-label">
                                      <Input
                                        type="checkbox"
                                        onChange={(e) => {
                                          props.onChange(e.target.checked);
                                          setIsQueuesTelephone(
                                            !isQueuesTelephone
                                          );
                                        }}
                                        checked={isQueuesTelephone}
                                        disabled={!queuesTelephony}
                                      />
                                      Exibir em monitoramento de filas quando
                                      offline
                                    </label>
                                    <FormTooltip text="Só é possível habilitar esta opção se tiver apenas uma fila de telefonia." />
                                  </>
                                )}
                                defaultValue={isQueuesTelephone}
                              />
                            </Row>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={queuesTelephony}
                                  placeholder="Selecione a(s) fila(s)"
                                  isClearable={true}
                                  isMulti={true}
                                  isDisabled={!isQueuesTelephone}
                                  value={props.value}
                                  valueController={setValue}
                                  fieldName="queues_telephone"
                                  labelName="name"
                                  valueName="id"
                                />
                              )}
                              control={control}
                              rules={{
                                validate: (value) => {
                                  if (isQueuesTelephone === true) {
                                    if (!value || !value.length) {
                                      return 'Selecione ao menos uma fila de telefonia';
                                    }
                                  }
                                  return true;
                                }
                              }}
                              name="queues_telephone"
                              defaultValue=""
                            />
                            <ErrorMessage
                              errors={errors}
                              name="queues_telephone"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Tipos de registro*
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={recordTypes ?? []}
                                  isMulti={true}
                                  value={props.value}
                                  valueController={setValue}
                                  fieldName="recordtypesid"
                                  labelName="name"
                                  valueName="id"
                                />
                              )}
                              control={control}
                              rules={{
                                validate: (value) => {
                                  if (!value || !value.length) {
                                    !verifyRoles(['USER_PERMISSIONS']) &&
                                      toast.error(
                                        'Tipo de registro é obrigatório!',
                                        {
                                          autoClose: 3000,
                                          closeOnClick: true
                                        }
                                      );

                                    return 'Tipo de registro é obrigatório!';
                                  }
                                  return true;
                                }
                              }}
                              name="recordtypesid"
                              defaultValue=""
                            />
                            <ErrorMessage
                              errors={errors}
                              name="recordtypesid"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">
                              Setor(es)
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={sectors}
                                  isMulti={true}
                                  value={props.value}
                                  valueController={setValue}
                                  fieldName="costscenterid"
                                  labelName="name"
                                  valueName="id"
                                />
                              )}
                              control={control}
                              name="costscenterid"
                              defaultValue=""
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Supervisores
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  isClearable={true}
                                  dataOptions={userList ?? []}
                                  isMulti={true}
                                  closeMenuOnSelect={false}
                                  value={props.value}
                                  valueController={setValue}
                                  fieldName="supervisorids"
                                  labelName="name"
                                  valueName="login"
                                />
                              )}
                              control={control}
                              name="supervisorids"
                              defaultValue=""
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">
                              Permissões de equipe
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  isClearable={true}
                                  dataOptions={teams}
                                  isMulti={true}
                                  closeMenuOnSelect={false}
                                  value={props.value}
                                  valueController={setValue}
                                  fieldName="teamsIds"
                                  labelName="name"
                                  valueName="id"
                                />
                              )}
                              control={control}
                              name="teamsIds"
                              defaultValue=""
                            />
                            <ErrorMessage
                              errors={errors}
                              name="teamsIds"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col md="6">
                            <FlexControllerV2
                              type="select"
                              name="ringgroups"
                              control={control}
                              label="Grupos de Toque"
                              options={ringGroupsOptions}
                              isMulti
                              closeMenuOnSelect={false}
                              isClearable
                              errors={errors}
                            />
                          </Col>
                        </Row>
                      </Row>
                      <Row>
                        <Col>
                          <h3 className="mb-1">Configurações de email</h3>
                        </Col>
                      </Row>

                      <Row>
                        <Col md="12">
                          <FormGroup className="mb-0">
                            <label className="form-control-label">
                              <input
                                type="checkbox"
                                checked={initialConfigSignatureEmail.active}
                                onChange={() => {
                                  setInitialConfigSignatureEmail({
                                    ...initialConfigSignatureEmail,
                                    active: !initialConfigSignatureEmail.active
                                  });
                                }}
                                style={{ marginRight: '0.35rem' }}
                              />
                              Vincular assinatura de email personalizada
                            </label>
                          </FormGroup>
                        </Col>
                      </Row>
                      {initialConfigSignatureEmail.active && (
                        <Row>
                          <Col>
                            <ReactQuill
                              modules={modules}
                              name="textEmailForaHorario"
                              className="editorText"
                              theme="snow"
                              defaultValue={
                                initialConfigSignatureEmail.signature
                              }
                              onChange={setDataEmailSignature}
                            />
                          </Col>
                        </Row>
                      )}

                      <Row
                        className="mb-1"
                        style={
                          verifyRoles(['USER_PENALTY'])
                            ? { display: 'block', padding: '1rem' }
                            : { display: 'none' }
                        }
                      >
                        {selectedQueues && (
                          <QueuePenaltyTable
                            selectedQueues={selectedQueues}
                            handleOpenModalUpdatePenality={
                              handleOpenModalUpdatePenality
                            }
                          />
                        )}
                      </Row>

                      <hr />

                      {loading ? (
                        <Row className="justify-content-md-center">
                          <ReactLoader />
                        </Row>
                      ) : null}
                      <ReactButton
                        btnColor="confirmation"
                        type="submit"
                        disabled={loading}
                      >
                        Salvar
                      </ReactButton>
                      <ReactButton
                        btnColor="cancelation"
                        onClick={() => cancelAction()}
                      >
                        Cancelar
                      </ReactButton>
                    </Form>
                  </>
                </CardBody>
              </Card>
            </div>
          </div>
        </Row>
        {login && (
          <EditPassword
            toggleModal={toggleModal}
            isOpen={openModal}
            login={login}
          />
        )}
      </Container>
      <ModalUpdatePenality
        setSelectedQueues={setSelectedQueues}
        selectedQueues={selectedQueues}
        queueUpdate={queueUpdatePenality}
        isModalOpen={openModalUpdatePenality}
        onModalToggle={setOpenModalUpdatePenality}
        unmountOnClose={true}
      />
    </>
  );
};

export default UserForm;
